/// <reference path="base.ts" />

namespace ui
{
	export namespace base
	{

		export abstract class HTMLPresentation<T extends HTMLElement = HTMLElement>
			extends BaseHTMLElement<T>
		{

			public reload( ...args: any[] ): void
			{
				return;
			}

			public rebuild(
				root: ui.base.BaseHTMLElement<HTMLElement>|JQuery<HTMLElement>,
				...data: any[]
			) : HTMLPresentation<T>
			{
				this.appendTo( root );

				return this;
			}

			protected constructor( tagName: string, root?: JQuery<HTMLElement> )
			{
				super( tagName );

				if ( root )
				{
					root.append( this.m_Root );
				}
			}

		}

	}
}
